import { ProcessElementsResource } from "core/stages-client";
import { ViewService } from "core/view.service";
import { AssociationService } from "process/associations/association.service";
import { ComplianceProcessAssociationStore } from "process/compliance/associations/compliance-process-association-store.logic";

export class ComplianceProcessCommentAssociationStore extends ComplianceProcessAssociationStore {
	constructor(
		viewService: ViewService,
		associationService: AssociationService,
		processElementsResource: ProcessElementsResource,
	) {
		super(viewService, associationService, processElementsResource);
	}

	override async getCombinedAssociations(
		_targetElementIdentities: string[],
		currentWorkspaceId: string,
		sourceElementType: string,
		sourceElementIdentity: string,
		path: string,
		page: number,
		pageSize: number,
		pv: string,
		associationId?: string,
	): Promise<SecuredPagedResult<stages.common.Association<stages.process.RemoteTargetElement>>> {
		// eslint-disable-next-line @typescript-eslint/return-await -- sorry, had to suppress this
		return await this.processElementsResource.getCombinedCommentAssociations(
			currentWorkspaceId,
			sourceElementType,
			sourceElementIdentity,
			{ associationId: associationId, path: path, page: page, pageSize: pageSize, pv: pv },
		);
	}
}
